export default "__VITE_ASSET__CvAA9Rc___"